module.exports = __webpack_public_path__ + "static/HelpScout-83d2fd1f95237a91d1f115709297d1ce.png";